import appModule from '../../app.module'

appModule.component('superUserBanner', {
  template: `
    <div class="super-user-banner" ng-if="$root.currentUser.isSuperUser && $root.currentUser.originalTenantId !== $root.currentUser.tenant.id">
      You are currently logged into {{$root.currentUser.tenant.name}}.
      <a ng-click="$root.returnToOriginalTenant()">Log out of this tenant.</a>
    </div>
  `,
})
